import { useEffect, useState } from "react";
import { fetchEventApprovalData, sendEventApprovalRequest } from "../Api/EventApproval";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
//import "../Styling/EventApproval.css";

const EventApproval = () => {
  const [approvals, setApprovals] = useState([]);

  useEffect(() => {
    const loadApprovals = async () => {
      try {
        const data = await fetchEventApprovalData();
        setApprovals(data.data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Event Approval Data");
      }
    };
    loadApprovals();
  }, []);

  const handleApprove = async (eventId) => {
    try {
      await sendEventApprovalRequest(eventId);
      toast.success(`🟢 Event ${eventId} Approved!`);
      setTimeout(() => window.location.reload(), 1000);
    } catch (error) {
      toast.error("❌ Error Sending Event Approval Request");
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">Event Approval</span>

          {approvals.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Event Id</th>
                      <th>Event Name</th>
                      <th>Event Type</th>
                      <th>Event Date</th>
                      <th>Event Location</th>
                      <th>Organizer Name</th>
                      <th>Budget Allocation</th>
                      <th>Department</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {approvals.map((approval, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{approval.eventId}</td>
                        <td>{approval.eventName}</td>
                        <td>{approval.eventType}</td>
                        <td>{new Date(approval.eventDate).toLocaleDateString()}</td>
                        <td>{approval.eventLocation}</td>
                        <td>{approval.organizerName}</td>
                        <td>{approval.budgetAllocation}</td>
                        <td>{approval.department}</td>
                        <td className={approval.approvalStatus === "W" ? "status-waiting" : "status-approved"}>
                          {approval.approvalStatus === "W" ? "Waiting" : "Approved"}
                        </td>
                        <td>
                          {approval.approvalStatus === "W" && (
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleApprove(approval.eventId)}
                              className="approve-btn"
                            >
                              Approve
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No event approval requests found.</p>
          )}
        </Container>
      </div>
  );
};

export default EventApproval;